module.exports = __webpack_public_path__ + "img/activity-types.4a9038b1.svg";